import { graphql, useStaticQuery } from 'gatsby'
import { get } from 'tiny-compose-fns/noFp'

export const useCustomTypePageMap = () => {
  const queryData = useStaticQuery(graphql`
    {
      prismicSettings {
        data {
          preview_map {
            api_id
            page {
              document {
                ...PageParentFields
                ...PageParentRecursive
              }
            }
          }
        }
      }
    }
  `)

  const previewMap = get('prismicSettings.data.preview_map', queryData, [])

  return previewMap.reduce((acc, curr) => {
    acc[curr.api_id] = curr

    return acc
  }, {})
}
